"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedCurrency = exports.CustomDunningDuration = exports.Edition = exports.ParticipantsType = exports.CancelContextReason = exports.CancelContextReasonCode = exports.TrialTypeForAnalytics = exports.AnnualToMonthlyDowngradeTypeForAnalytics = exports.ResetType = exports.HydraBillingFrequency = exports.HydraKeys = exports.PurchaseFor = exports.TransitionTime = exports.OfferingName = exports.PageLayer = exports.InfoMessage = exports.PricingPlanType = exports.PricingPlanStatus = exports.OrderActionType = exports.OrderRequestMetaData = exports.BillingBehaviourType = exports.EndsAtType = exports.PatchOperation = exports.UNLIMITED_UNIT_COUNT = exports.EVALUATION_UNIT_COUNT = exports.SubscriptionScheduleAction = exports.RelationshipPathType = exports.CCPPricing = exports.Currency = exports.PricingPlanCycle = void 0;
// TODO copy over tyoes from ccp to avoid curcular deps
var PricingPlanCycle;
(function (PricingPlanCycle) {
    PricingPlanCycle["MONTHLY"] = "MONTHLY";
    PricingPlanCycle["ANNUAL"] = "ANNUAL";
})(PricingPlanCycle = exports.PricingPlanCycle || (exports.PricingPlanCycle = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["AUD"] = "AUD";
    Currency["JPY"] = "JPY";
    Currency["EUR"] = "EUR";
    Currency["GBP"] = "GBP";
})(Currency = exports.Currency || (exports.Currency = {}));
var CCPPricing;
(function (CCPPricing) {
    CCPPricing["COMMUNITY"] = "COMMUNITY";
    CCPPricing["OPEN_SOURCE"] = "OPEN_SOURCE";
    CCPPricing["CLASSROOM"] = "CLASSROOM";
    CCPPricing["COMMERCIAL"] = "COMMERCIAL";
    CCPPricing["DEFAULT_PRICING"] = "DEFAULT_PRICING";
    CCPPricing["FOUNDATION_FREE"] = "FOUNDATION_FREE";
    CCPPricing["ACADEMIC"] = "ACADEMIC";
})(CCPPricing = exports.CCPPricing || (exports.CCPPricing = {}));
var RelationshipPathType;
(function (RelationshipPathType) {
    RelationshipPathType["FAMILY_CONTAINER"] = "FAMILY_CONTAINER";
    RelationshipPathType["APP_DEPENDENCE"] = "APP_DEPENDENCE";
    RelationshipPathType["SANDBOX_DEPENDENCE"] = "SANDBOX_DEPENDENCE";
    RelationshipPathType["SANDBOX_GRANT"] = "SANDBOX_GRANT";
    RelationshipPathType["ENTERPRISE"] = "ENTERPRISE";
    RelationshipPathType["ADDON_DEPENDENCE"] = "ADDON_DEPENDENCE";
    RelationshipPathType["MULTI_INSTANCE"] = "MULTI_INSTANCE";
    RelationshipPathType["COLLECTION"] = "COLLECTION";
    RelationshipPathType["ENTERPRISE_SANDBOX_GRANT"] = "ENTERPRISE_SANDBOX_GRANT";
})(RelationshipPathType = exports.RelationshipPathType || (exports.RelationshipPathType = {}));
var SubscriptionScheduleAction;
(function (SubscriptionScheduleAction) {
    SubscriptionScheduleAction["UPDATE"] = "UPDATE";
    SubscriptionScheduleAction["CANCEL"] = "CANCEL";
    SubscriptionScheduleAction["UPDATE_CANCEL"] = "UPDATE_CANCEL";
})(SubscriptionScheduleAction = exports.SubscriptionScheduleAction || (exports.SubscriptionScheduleAction = {}));
/**
 * Common to all entitlements.
 * Extended variations are in legacy and graphql interfaces. Examples:
 * @see Entitlement
 * @see StatuspageEntitlement
 */
exports.EVALUATION_UNIT_COUNT = -987654321;
exports.UNLIMITED_UNIT_COUNT = 987654321;
var PatchOperation;
(function (PatchOperation) {
    PatchOperation["REMOVE"] = "remove";
    PatchOperation["REPLACE"] = "replace";
})(PatchOperation = exports.PatchOperation || (exports.PatchOperation = {}));
var EndsAtType;
(function (EndsAtType) {
    EndsAtType["TIMESTAMP"] = "TIMESTAMP";
    EndsAtType["DURATION"] = "DURATION";
})(EndsAtType = exports.EndsAtType || (exports.EndsAtType = {}));
var BillingBehaviourType;
(function (BillingBehaviourType) {
    BillingBehaviourType["PAUSE_BILLING"] = "PAUSE_BILLING";
})(BillingBehaviourType = exports.BillingBehaviourType || (exports.BillingBehaviourType = {}));
var OrderRequestMetaData;
(function (OrderRequestMetaData) {
    OrderRequestMetaData["SUPPORT_TICKET_NUMBER"] = "supportTicketNumber";
    OrderRequestMetaData["HAND_NOTE"] = "handNote";
    OrderRequestMetaData["ACTION_TYPE"] = "actionType";
    OrderRequestMetaData["SEN"] = "sen";
    OrderRequestMetaData["CONTRACT_TYPE"] = "contractType";
    OrderRequestMetaData["CONTRACT_ID"] = "contractId";
})(OrderRequestMetaData = exports.OrderRequestMetaData || (exports.OrderRequestMetaData = {}));
var OrderActionType;
(function (OrderActionType) {
    OrderActionType["ADD_OR_REMOVE_PROMOTIONS"] = "addOrRemovePromotions";
})(OrderActionType = exports.OrderActionType || (exports.OrderActionType = {}));
var PricingPlanStatus;
(function (PricingPlanStatus) {
    PricingPlanStatus["ACTIVE"] = "ACTIVE";
    PricingPlanStatus["INACTIVE"] = "INACTIVE";
})(PricingPlanStatus = exports.PricingPlanStatus || (exports.PricingPlanStatus = {}));
var PricingPlanType;
(function (PricingPlanType) {
    PricingPlanType["COMMUNITY"] = "COMMUNITY";
    PricingPlanType["OPEN_SOURCE"] = "OPEN_SOURCE";
    PricingPlanType["CLASSROOM"] = "CLASSROOM";
    PricingPlanType["COMMERCIAL"] = "COMMERCIAL";
    PricingPlanType["EVALUATION"] = "EVALUATION";
    PricingPlanType["FOUNDATION_FREE"] = "FOUNDATION_FREE";
})(PricingPlanType = exports.PricingPlanType || (exports.PricingPlanType = {}));
var InfoMessage;
(function (InfoMessage) {
    InfoMessage["AMENDMENT_SCHEDULED"] = "Amendments pre-populated from scheduled changes";
    InfoMessage["PRICING_PLAN_ELIGIBILITY_WARNING"] = "Pricing plan has been auto-selected based on the pricing eligibility set on the billing or sold-to address of the billing account. If the pricing eligibility isn\u2019t set for either address, the plan is set to Commercial by default.";
})(InfoMessage = exports.InfoMessage || (exports.InfoMessage = {}));
var PageLayer;
(function (PageLayer) {
    PageLayer[PageLayer["ICONS"] = 1] = "ICONS";
    PageLayer[PageLayer["TABLE_ICONS"] = 2] = "TABLE_ICONS";
    PageLayer[PageLayer["HEADER_ICONS"] = 2] = "HEADER_ICONS";
    PageLayer[PageLayer["TABLE_HEADERS"] = 5] = "TABLE_HEADERS";
    PageLayer[PageLayer["APP_BANNER"] = 100] = "APP_BANNER";
    PageLayer[PageLayer["INLINE_EDIT"] = 300] = "INLINE_EDIT";
    PageLayer[PageLayer["SIDEBAR_OVERLAY"] = 500] = "SIDEBAR_OVERLAY";
    PageLayer[PageLayer["SIDEBAR"] = 505] = "SIDEBAR";
    PageLayer[PageLayer["MODAL"] = 510] = "MODAL";
    PageLayer[PageLayer["SIDEBAR_SELECT"] = 600] = "SIDEBAR_SELECT";
    PageLayer[PageLayer["NOTIFICATIONS"] = 10000] = "NOTIFICATIONS";
})(PageLayer = exports.PageLayer || (exports.PageLayer = {}));
var OfferingName;
(function (OfferingName) {
    OfferingName["AUDIENCE_SPECIFIC"] = "Audience-Specific";
})(OfferingName = exports.OfferingName || (exports.OfferingName = {}));
var TransitionTime;
(function (TransitionTime) {
    TransitionTime["IMMEDIATE"] = "IMMEDIATE";
    TransitionTime["NEXT_CYCLE"] = "NEXT_CYCLE";
    TransitionTime["SCHEDULED"] = "SCHEDULED";
})(TransitionTime = exports.TransitionTime || (exports.TransitionTime = {}));
var PurchaseFor;
(function (PurchaseFor) {
    PurchaseFor["ANNUAL_TERM"] = "annualTerm";
    PurchaseFor["ANNUAL_AUTO_RENEW"] = "annualAutoRenew";
})(PurchaseFor = exports.PurchaseFor || (exports.PurchaseFor = {}));
var HydraKeys;
(function (HydraKeys) {
    HydraKeys["BILLING_FREQUENCY"] = "billingFrequency";
})(HydraKeys = exports.HydraKeys || (exports.HydraKeys = {}));
var HydraBillingFrequency;
(function (HydraBillingFrequency) {
    HydraBillingFrequency["ANNUAL"] = "Annual";
})(HydraBillingFrequency = exports.HydraBillingFrequency || (exports.HydraBillingFrequency = {}));
var ResetType;
(function (ResetType) {
    ResetType["SALE_TRANSITION_RESET"] = "SALE_TRANSITION_RESET";
    ResetType["HARD_RESET"] = "HARD_RESET";
    ResetType["ORDER_ITEM"] = "ORDER_ITEM";
})(ResetType = exports.ResetType || (exports.ResetType = {}));
var AnnualToMonthlyDowngradeTypeForAnalytics;
(function (AnnualToMonthlyDowngradeTypeForAnalytics) {
    AnnualToMonthlyDowngradeTypeForAnalytics["ANNUAL_TERMED_TO_MONTHLY_IMMEDIATE_DOWNGRADE"] = "annualTermedToMonthlyImmediateDowngrade";
    AnnualToMonthlyDowngradeTypeForAnalytics["ANNUAL_EVERGREEN_TO_MONTHLY_IMMEDIATE_DOWNGRADE"] = "annualEvergreenToMonthlyImmediateDowngrade";
    AnnualToMonthlyDowngradeTypeForAnalytics["ANNUAL_EVERGREEN_TO_MONTHLY_SCHEDULED_DOWNGRADE"] = "annualEvergreenToMonthlyScheduledDowngrade";
    AnnualToMonthlyDowngradeTypeForAnalytics["ANNUAL_EVERGREEN_TO_MONTHLY_IMMEDIATE_DOWNGRADE_WITH_PROMOTIONS"] = "annualEvergreenToMonthlyImmediateDowngradeWithPromotions";
    AnnualToMonthlyDowngradeTypeForAnalytics["ANNUAL_TERMED_TO_MONTHLY_IMMEDIATE_DOWNGRADE_WITH_PROMOTIONS"] = "annualTermedToMonthlyImmediateDowngradeWithPromotions";
})(AnnualToMonthlyDowngradeTypeForAnalytics = exports.AnnualToMonthlyDowngradeTypeForAnalytics || (exports.AnnualToMonthlyDowngradeTypeForAnalytics = {}));
var TrialTypeForAnalytics;
(function (TrialTypeForAnalytics) {
    TrialTypeForAnalytics["ANNUAL_TRIAL"] = "annualTrial";
    TrialTypeForAnalytics["ANNUAL_UPGRADE_TRIAL"] = "annualUpgradeTrial";
    TrialTypeForAnalytics["MONTHLY_TRIAL"] = "monthlyTrial";
    TrialTypeForAnalytics["MONTHLY_UPGRADE_TRIAL"] = "monthlyUpgradeTrial";
})(TrialTypeForAnalytics = exports.TrialTypeForAnalytics || (exports.TrialTypeForAnalytics = {}));
var CancelContextReasonCode;
(function (CancelContextReasonCode) {
    CancelContextReasonCode["VOID_IN_STRIPE"] = "VOID_IN_STRIPE";
    CancelContextReasonCode["NO_BILL_TO"] = "NO_BILL_TO";
    CancelContextReasonCode["NO_PAYMENT_METHOD"] = "NO_PAYMENT_METHOD";
    CancelContextReasonCode["ZERO_DOLLAR"] = "ZERO_DOLLAR";
    CancelContextReasonCode["CREDIT_ELIGIBILITY_CHECK_FAILED"] = "CREDIT_ELIGIBILITY_CHECK_FAILED";
})(CancelContextReasonCode = exports.CancelContextReasonCode || (exports.CancelContextReasonCode = {}));
var CancelContextReason;
(function (CancelContextReason) {
    CancelContextReason["VOID_IN_STRIPE"] = "Void in stripe";
    CancelContextReason["NO_BILL_TO"] = "No billing address";
    CancelContextReason["NO_PAYMENT_METHOD"] = "No payment method";
    CancelContextReason["ZERO_DOLLAR"] = "Zero dollar";
    CancelContextReason["CREDIT_ELIGIBILITY_CHECK_FAILED"] = "Credit eligibility check failure";
})(CancelContextReason = exports.CancelContextReason || (exports.CancelContextReason = {}));
var ParticipantsType;
(function (ParticipantsType) {
    ParticipantsType["ENTITLEMENT"] = "ENTITLEMENT";
    ParticipantsType["ORDER_ITEM"] = "ORDER_ITEM";
    ParticipantsType["QUOTE_ITEM"] = "QUOTE_ITEM";
})(ParticipantsType = exports.ParticipantsType || (exports.ParticipantsType = {}));
var Edition;
(function (Edition) {
    Edition["FREE"] = "Free";
    Edition["FREE_STANDARD"] = "Free Standard";
})(Edition = exports.Edition || (exports.Edition = {}));
var CustomDunningDuration;
(function (CustomDunningDuration) {
    CustomDunningDuration["REGULAR"] = "REGULAR";
    CustomDunningDuration["ACCELERATED"] = "ACCELERATED";
})(CustomDunningDuration = exports.CustomDunningDuration || (exports.CustomDunningDuration = {}));
var SupportedCurrency;
(function (SupportedCurrency) {
    SupportedCurrency["USD"] = "USD";
    SupportedCurrency["JPY"] = "JPY";
})(SupportedCurrency = exports.SupportedCurrency || (exports.SupportedCurrency = {}));
